import ResponsiveContainer from "../../../../../../packages/design-system/src/ResponsiveContainer";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  ResponsiveContainer,
  Text,
  React
};